var KEYCODE_ENTER = 13;

angular.module('impactx.autoComplete').directive('handleSpecialEntryKeydown', function () {
    return {
        restrict: 'A',
        require: 'mdAutocomplete',
        link: function (scope, element) {
            var autoCompleteCtrl = element.controller('mdAutocomplete');
            // "override" the original keydown-event function, but keep it around for "super"-call inside the new one
            var superKeydown = autoCompleteCtrl.keydown;
            autoCompleteCtrl.keydown = function (event) {
                if (event.keyCode === KEYCODE_ENTER) {
                    // get the actual entry-object to be selected on keydown
                    var newSelected = autoCompleteCtrl.matches[autoCompleteCtrl.index];
                    if (newSelected && (newSelected.id < 0 || newSelected.readOnly)) {
                        event.stopPropagation();
                        return;
                    }
                }
                // call "super"-keydown for regular event processing
                superKeydown(event);
            };
        }
    };
});